import React, {useContext, useEffect, useState} from 'react';
import {
    Button, ButtonTypes,
    Card, CardBody, CardHeader,
    customToast,
    DisabledContext,
    Text,
    Title,
    Variants,
    WidthConstrainedContainer
} from "toolbox-react-frontend-components";
import {route} from "ziggy-js";
import LoadingPane from "../../../components/LoadingPane";
import EditSettingModal from "./components/EditSettingModal";

const IndexSetting = (props) => {
    const {

    } = props;

    const {
        disabled
    } = useContext(DisabledContext);

    const [data, setData]                           = useState(null);
    const [loaded, setLoaded]                       = useState(false);
    const [editSettingModal, setEditSettingModal]   = useState(null);

    useEffect(() => {
        if (!loaded) {
            loadPageData();
        }
    }, [loaded]);


    const loadPageData = () => {
        axios.get(route('api.admin.setting.index'))
            .then((response) => {
                if (!!response && !!response.data) {
                    setData(response.data);
                    setLoaded(true);
                } else {
                    customToast({
                        title:      'Settings data not found. Please refresh the page to try again.',
                        variant:    Variants.Danger
                    });
                }
            })
            .catch((error) => {
                console.log(error);
            });
    }

    const settingsExists = () => {
        return !!data && !!data.data && data.data.length > 0;
    }

    const renderNoSettings = () => {
        return (
            <Text className={'mb-0'}>
                No settings have been created.
            </Text>
        );
    }

    const renderSetting = (index, setting) => {
        return (
            <div
                key={setting.id}
                className={'row m-0 p-0 d-flex justify-content-between align-items-center'+(index+1 !== data.data.length ? " mb-4" : "")}
            >
                <div className="col-12 col-md-8 m-0 p-0 pb-3 pb-md-0 pe-md-2 d-flex flex-column justify-content-center align-items-md-start">
                    <div className={'w-100 h5'}>{setting.label}</div>
                    <div className={'w-100 '}>{setting.value}</div>
                </div>
                <div className="col-12 col-md-4 m-0 p-0 ps-md-2 d-flex justify-content-md-end align-items-md-center">
                    <Button
                        label={!!setting.editable ? 'Edit' : ' Not Editable'}
                        disabled={disabled || !setting.editable}
                        onClick={(event) => !!setting.editable ? setEditSettingModal(setting) : {}}
                        type={ButtonTypes.Outline}
                        variant={!!setting.editable ? Variants.Primary : Variants.Dark}
                    />
                </div>
            </div>
        );
    }

    if (!loaded) {
        return (
            <LoadingPane />
        );
    }

    return (
        <WidthConstrainedContainer maxWidth={1000}>
            <Card noMargin={true}>
                <CardHeader
                    leftSlot={(
                        <Title
                            title={'Settings'}
                            noMargin={true}
                        />
                    )}
                />
                <CardBody
                    className={'pt-3'}
                >
                    {settingsExists() ? (
                        <>
                            {data.data.map((setting, index) => renderSetting(index, setting))}
                            <EditSettingModal
                                setting={editSettingModal}
                                onClose={() => setEditSettingModal(null)}
                                onSuccess={() => {
                                    setEditSettingModal(null);
                                    setLoaded(false);
                                }}
                            />
                        </>
                    ) : renderNoSettings()}
                </CardBody>
            </Card>
        </WidthConstrainedContainer>
    );

}

export default IndexSetting;
